export default __webpack_public_path__ + "static/media/level12.0fcf769e.svg";